import React from 'react'
import { NumberInput } from 'react-admin'
import { validRange } from 'validations'
import { DependentFieldContainer, FieldWrapper, TooltipIconWrapper } from '../ProjectConfigurations.styles'
import { SnowLossPercentageTooltip } from './SnowLossPercentageTooltip'

interface SnowLossPercentageFieldProps {
  allowEdit: boolean
  countryIso2: string
  style: React.CSSProperties
  [key: string]: any // For spreading props
}

export const SnowLossPercentageField: React.FC<SnowLossPercentageFieldProps> = ({
  allowEdit,
  countryIso2,
  style,
  ...props
}) => {
  const isUS = countryIso2 === 'US'

  return (
    <DependentFieldContainer>
      <FieldWrapper style={style}>
        <NumberInput
          style={style}
          source="sam_snow"
          label="Snow Loss (%)"
          {...props}
          name="sam_snow"
          endAdornment="%"
          disabled={!allowEdit}
          validate={validRange(0, 100, true, { fieldName: 'Snow Loss' })}
        />
      </FieldWrapper>
      {isUS && <SnowLossPercentageTooltip countryIso2={countryIso2} />}
    </DependentFieldContainer>
  )
}
